import { NgxsDataRepository } from '@angular-ru/ngxs/repositories'
import { Computed, DataAction, Payload } from '@angular-ru/ngxs/decorators'
// eslint-disable-next-line @nx/enforce-module-boundaries
import type { TabNavItem, TabValue } from '@wm-front/shared/tabs'
import { map, Observable } from 'rxjs'
import produce from 'immer'

export interface TabsModelState {
  currentTab: TabValue
  tabs: TabNavItem[]
}

type TabsStateType<T> = T & TabsModelState

/***/
export class BaseTabsState<T> extends NgxsDataRepository<TabsStateType<T>> {
  protected constructor() {
    super()
  }

  /**
   * Returns the current tab as an observable
   */
  @Computed()
  public get currentTab$(): Observable<TabValue> {
    return this.state$.pipe(map((state) => state.currentTab))
  }

  /**
   * Returns the current tab
   */
  @Computed()
  public get currentTab(): TabValue {
    return this.snapshot.currentTab
  }

  /**
   * Returns the tabs
   */
  @Computed()
  public get tabs$(): Observable<TabNavItem[]> {
    return this.state$.pipe(map((state) => state.tabs))
  }

  /**
   * Set a new current tab
   */
  @DataAction()
  public setCurrentTab(@Payload('currentTab') currentTab: TabValue): void {
    const state = this.getState()
    const tabs = produce(state.tabs, (draftState: TabNavItem[]) => {
      draftState.forEach((tab) => {
        tab.active = tab.value === currentTab
      })
    })

    this.ctx.setState({
      ...state,
      currentTab,
      tabs,
    })
  }
}
